import React, { useEffect, useRef, useState } from "react";
import AsyncButton from "../../components/common/AsyncButton";
import AsyncSection from "../../components/common/AsyncSection";
import { useAsyncAction } from "../../components/common/useAsyncAction";
import { isActive, isExpired, isStudent, isTrial, useAuth } from "../../contexts/AuthContext";
import { Menu, Grid2, Alert, Box, Button, IconButton, Paper, Snackbar, Stack, Checkbox, TextField, Divider, Chip, Card, CardContent, CardHeader, Tabs, Tab, RadioGroup, FormControlLabel, Radio, Switch, FormControlLabel as MuiFormControlLabel } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import { SampleData } from "./SampleData";
import { useNavigate } from "react-router-dom";
import EditNoteIcon from '@mui/icons-material/EditNote';
import PreviewIcon from '@mui/icons-material/Preview';
import Tooltip from '@mui/material/Tooltip';
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase, getAssessmentMgmtBase } from "../../config/apiBase";
import Delete from "@mui/icons-material/Delete";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import {
    Add as AddIcon,
    MoreVert as MoreVertIcon,
    Search as SearchIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Assignment as AssignmentIcon,
    AddCircle,
} from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import ClassIcon from '@mui/icons-material/Class';
import SchoolIcon from '@mui/icons-material/School';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PersonIcon from "@mui/icons-material/Person";
import CategoryIcon from '@mui/icons-material/Category';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LabelIcon from '@mui/icons-material/Label';
import PropTypes from 'prop-types';



//<Divider style={{ paddingTop: '20px' }} />
const AssessmentList = () => {
    const navigate = useNavigate();
    const { user, logout, refreshUser } = useAuth();
    const tabsRef = useRef(null);
    const createPanelRef = useRef(null);
    const quickPanelRef = useRef(null);
    const listPanelRef = useRef(null);
    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const [tourOpen, setTourOpen] = useState(false);
    const [tourSection, setTourSection] = useState(0);
    const handleClose = () => {
        setState({ ...state, open: false });
    };
    const isTrialState = isTrial();
    const isExpiredState = isExpired();
    const [enrolledUsers, setEnrolledUsers] = useState([]);

    const [categories, setCategories] = useState({})
    const [subjects, setSubjects] = useState([])

    const getUserData = async () => {
        const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enrolled`,
            {
                "EnrollerID": user["id"],
                "OnlyActivated": true,
            },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        //console.log(uinfo.response)
        return uinfo.response["EnrolledUsers"]
        //ID, Username
    }

    const getCategories = async () => {
        const categories = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/categories`,
            {},
            'POST',
            { "authorization": user["token"] },
            false)
        if (categories["unauthenticated"] == true || categories["unauthorized"] == true) {
            logout(user);
        }
        if (categories.internal) {
            return undefined
        }
        console.log(categories)
        const hash = categories.response.Categories.reduce((acc, item) => {
            acc[item.Sname] = acc[item.Sname] || {};
            acc[item.Sname][item.Cls] = acc[item.Sname][item.Cls] || [];
            acc[item.Sname][item.Cls].push(item.Cname);
            return acc;
        }, {});

        console.log(hash);
        return hash
    }


    useEffect(() => {
        //Some function
        getUserData().then(data => setEnrolledUsers(data))

        getCategories().then(data => {
            setCategories(data)
            if (data) {
                // Extract subjects from categories
                const subjectList = Object.keys(data);
                setSubjects(subjectList);
            }
        })

    }, [])

    const [dialog, setDialog] = useState({ open: false, user: false, group: false, question: false, id: "", button: "", content: "" })
    const { run: runDialog, loading: dialogSubmitting } = useAsyncAction();

    const handleDialogClose = () => {
        setDialog({ open: false })
    }

    const handleDialogContinue = async () => {
        await runDialog(async () => {
            const status = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/delete`,
                {
                    "ID": dialog.id,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (status["unauthenticated"] == true || status["unauthorized"] == true) {
                logout(user);
            }
            setState({ open: true, severity: "success", message: "Assessment deleted successfully" })
            setDialog({ open: false })
            refreshUser();
        });
    }
    //Parent/Teacher sees create button
    //List of tests, columns and actions need to be planned based on user
    const RenderCreate = () => {
        const [createData, setCreateData] = useState({
            name: '',
            subject: '',
            class: '',
            timed: false,
            durationHours: '',
            durationMinutes: '',
        });

        // Auto-select first subject when subjects are loaded
        useEffect(() => {
            if (subjects.length > 0 && !createData.subject && Object.keys(categories).length > 0) {
                const firstSubject = subjects[0];
                setCreateData(prev => {
                    if (prev.subject) return prev; // Already initialized
                    const newData = { ...prev, subject: firstSubject, class: '' };
                    // Auto-select first class if available
                    if (categories[firstSubject]) {
                        const classes = Object.keys(categories[firstSubject]);
                        if (classes.length > 0) {
                            newData.class = classes[0];
                        }
                    }
                    return newData;
                });
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [subjects.length, Object.keys(categories).length]);

        const { run: runCreate, loading: creating } = useAsyncAction();

        const handleChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            if (name === 'subject') {
                // Reset class when subject changes
                setCreateData({ ...createData, subject: value, class: '' });
                // Auto-select first class for new subject
                if (categories[value]) {
                    const classes = Object.keys(categories[value]);
                    if (classes.length > 0) {
                        setTimeout(() => {
                            setCreateData(prev => ({ ...prev, class: classes[0] }));
                        }, 0);
                    }
                }
            } else {
                setCreateData({ ...createData, [name]: value });
            }
        };
        const handleCreate = async (event) => {
            event.preventDefault();
            await runCreate(async () => {
                const hours = parseInt(createData.durationHours, 10) || 0;
                const minutes = parseInt(createData.durationMinutes, 10) || 0;
                const durationMinutes = createData.timed ? (hours * 60 + minutes) : 0;
                const status = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/create`,
                    {
                        "Aname": createData.name,
                        "Asubject": createData.subject,
                        "Aclass": createData.class,
                        "Atype": "assignment",
                        "Duration": durationMinutes.toString(),
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if ((isTrialState || isExpiredState) && status.unauthorized) {
                    setState({ open: true, severity: "error", message: "Your trial limit is over. Activate to create." })
                    navigate("/app/activate")
                } else if (status["unauthenticated"] == true || status["unauthorized"] == true) {
                    logout(user);
                } else if (status.alreadyExists) {
                    //alert("username already exists")
                    setState({ open: true, severity: "warning", message: "Assessment name alreday exists" })
                } else if (status.iserror) {
                    console.log(status)

                    setState({ open: true, severity: "error", message: "Error creating Assessment" })
                } else {
                    console.log(status)
                    setState({ open: true, severity: "success", message: "Assessment created successfully" })
                    navigate("/app/practice/edit/" + status.response["ID"])
                }
            });
        };
        /*
        <CardHeader display="none" title={<Typography sx={{ display:"none", fontWeight: 'bold' }} variant="h5">Create Assessment</Typography>} />
        */
        return (
            <Paper
                elevation={0}
                sx={{
                    borderRadius: '0 0 16px 16px',
                    boxShadow: (theme) => theme.palette.mode === 'dark'
                        ? '0 8px 32px rgba(0,0,0,0.5)'
                        : '0 8px 32px rgba(0,0,0,0.12)',
                    width: '100%',
                    overflow: 'hidden',
                    backgroundColor: 'background.paper',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    marginTop: 0,
                }}
            >
                <Box sx={{ padding: "20px 30px" }}>
                    <Grid2 container spacing={4}>
                        <Grid2 size={{ xs: 12, sm: 12, md: 8 }}>
                            <Stack spacing={3}>
                                <Box>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <AssignmentIcon color="primary" />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Name
                                        </Typography>
                                    </Stack>
                                    <TextField
                                        label={createData.name ? "" : "Assignment Name"}
                                        variant="outlined"
                                        name="name"
                                        value={createData.name}
                                        onChange={handleChange}
                                        required
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                    />
                                </Box>
                                <Grid2 container spacing={2}>
                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <ClassIcon sx={{ color: "orange" }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                                Subject
                                            </Typography>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.subject || ''}
                                                onChange={handleChange}
                                                name="subject"
                                                displayEmpty
                                                sx={(theme) => ({
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '1px',
                                                        borderStyle: 'solid',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '2px',
                                                        borderColor: theme.palette.primary.main,
                                                    },
                                                })}
                                            >
                                                {subjects && subjects.map((row) => (
                                                    <MenuItem key={row} value={row}>{row}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <SchoolIcon sx={{ color: "brown" }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                                Class
                                            </Typography>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.class || ''}
                                                onChange={handleChange}
                                                name="class"
                                                displayEmpty
                                                disabled={!createData.subject}
                                                sx={(theme) => ({
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '1px',
                                                        borderStyle: 'solid',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '2px',
                                                        borderColor: theme.palette.primary.main,
                                                    },
                                                })}
                                            >
                                                {createData.subject && categories[createData.subject] && Object.keys(categories[createData.subject]).map((cls) => (
                                                    <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                </Grid2>
                                <Box>
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2, flexWrap: 'wrap' }}>
                                        <Checkbox
                                            checked={createData.timed}
                                            onChange={(e) => {
                                                setCreateData({
                                                    ...createData,
                                                    timed: e.target.checked,
                                                    durationHours: e.target.checked ? createData.durationHours : '',
                                                    durationMinutes: e.target.checked ? createData.durationMinutes : ''
                                                });
                                            }}
                                            color="primary"
                                        />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Timed
                                        </Typography>
                                        {createData.timed && (
                                            <>
                                                <TextField
                                                    label="Hours"
                                                    variant="outlined"
                                                    name="durationHours"
                                                    type="number"
                                                    value={createData.durationHours}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const formatted = value.replace(/[^\d]/g, '').slice(0, 2);
                                                        setCreateData({ ...createData, durationHours: formatted });
                                                    }}
                                                    placeholder="00"
                                                    inputProps={{ min: 0, max: 99 }}
                                                    sx={{ width: '100px' }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <Typography variant="h6" sx={{ color: 'text.secondary' }}>:</Typography>
                                                <TextField
                                                    label="Minutes"
                                                    variant="outlined"
                                                    name="durationMinutes"
                                                    type="number"
                                                    value={createData.durationMinutes}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const formatted = value.replace(/[^\d]/g, '').slice(0, 2);
                                                        const numValue = parseInt(formatted, 10);
                                                        if (isNaN(numValue) || numValue <= 59) {
                                                            setCreateData({ ...createData, durationMinutes: formatted });
                                                        }
                                                    }}
                                                    placeholder="00"
                                                    inputProps={{ min: 0, max: 59 }}
                                                    sx={{ width: '100px' }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </>
                                        )}
                                    </Stack>
                                </Box>
                                <Box display="flex" justifyContent="center" sx={{ pt: 2 }}>
                                    <AsyncButton type="submit" variant="contained" color="primary" onClick={handleCreate} loading={creating}>
                                        <AddCircle /> &nbsp; Create
                                    </AsyncButton>
                                </Box>
                            </Stack>
                        </Grid2>
                    </Grid2>
                    <Box display="none" justifyContent="center" alignItems="center">
                        <TextField
                            label="Name"
                            variant="outlined"
                            name="name"
                            value={createData.name}
                            onChange={handleChange}
                            required
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                        />
                        <TextField
                            label="Subject"
                            variant="outlined"
                            name="subject"
                            required
                            value={createData.subject}
                            onChange={handleChange}
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                        />
                        <TextField
                            label="Class"
                            variant="outlined"
                            name="class"
                            required
                            value={createData.class}
                            onChange={handleChange}
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                        />
                        <AsyncButton type="submit" variant="contained" color="primary" onClick={handleCreate} loading={creating}>
                            Create
                        </AsyncButton>

                    </Box>
                </Box>
            </Paper>
        );
    };

    const RenderList = () => {
        const [assessmentData, setAssessmentData] = useState({
            'whose': "self",
            'list': [],
            'type': "0",
            'status': "0"
        });
        const { run: runListLoad, loading: listLoading } = useAsyncAction();

        const getSelfAssessmentData = async (type, status) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/list`,
                {
                    "CreatorID": user["id"],
                    "Type": type,
                    "Status": status,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["AssessmentInfo"]
        }

        const getAssessmentData = async (userID, type, status) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assigned/user`,
                {
                    "UserID": userID,
                    "Type": type,
                    "Status": status,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["AssessmentInfo"]
        }

        useEffect(() => {
            //Some function
            if (assessmentData.whose === "self") {
                getSelfAssessmentData(assessmentData.type, assessmentData.status).then(data => setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'type': assessmentData.type, 'status': assessmentData.status }))
            } else {
                getAssessmentData(assessmentData.whose, assessmentData.filter).then(data => setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'type': assessmentData.type, 'status': assessmentData.status }))
            }
        }, [])


        const handleChange = async (e) => {
            e.preventDefault();
            const whose = e.target.value;
            await runListLoad(async () => {
                const type = parseInt(assessmentData.type, 10);
                const status = parseInt(assessmentData.status, 10);
                if (whose === "self") {
                    const data = await getSelfAssessmentData(type, status);
                    setAssessmentData({ 'whose': whose, 'list': data, 'type': assessmentData.type, 'status': assessmentData.status });
                } else {
                    const data = await getAssessmentData(whose, type, status);
                    setAssessmentData({ 'whose': whose, 'list': data, 'type': assessmentData.type, 'status': assessmentData.status });
                }
            });
        }

        /*
        const filterChange = async (e) => {
            e.preventDefault();
            const filter = parseInt(e.target.value)
            if (assessmentData.whose === "self") {
                getSelfAssessmentData(filter).then(data => setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'filter': filter }))
            } else {
                getAssessmentData(assessmentData.whose, filter).then(data => setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'filter': filter }))
            }
        }
        */

        const typeChange = async (e) => {
            e.preventDefault();
            const type = parseInt(e.target.value, 10);
            await runListLoad(async () => {
                const status = parseInt(assessmentData.status, 10);
                if (assessmentData.whose === "self") {
                    const data = await getSelfAssessmentData(type, status);
                    setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'type': type, 'status': assessmentData.status });
                } else {
                    const data = await getAssessmentData(assessmentData.whose, type, status);
                    setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'type': type, 'status': assessmentData.status });
                }
            });
        }

        const statusChange = async (e) => {
            e.preventDefault();
            const status = parseInt(e.target.value, 10);
            await runListLoad(async () => {
                const type = parseInt(assessmentData.type, 10);
                if (assessmentData.whose === "self") {
                    const data = await getSelfAssessmentData(type, status);
                    setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'type': assessmentData.type, 'status': status });
                } else {
                    const data = await getAssessmentData(assessmentData.whose, type, status);
                    setAssessmentData({ 'whose': assessmentData.whose, 'list': data, 'type': assessmentData.type, 'status': status });
                }
            });
        }
        /*
                                <Box display="none" sx={{ marginBottom: "20px", color: "primary.main" }}>

                            <FormControl sx={{ marginLeft: "20px" }}>
                                <RadioGroup row>
                                    <FormControlLabel value="0" control={<Radio />} label="All" />

                                    {
                                        assessmentData.whose === "self" ?
                                            <>
                                                <FormControlLabel value="6" control={<Radio />} label="Closed" onChange={filterChange} />
                                                <FormControlLabel value="7" control={<Radio />} label="Active" onChange={filterChange} />
                                                <FormControlLabel value="8" control={<Radio />} label="Draft" onChange={filterChange} />
                                                {isActive() ?
                                                    <>
                                                        <FormControlLabel value="2" control={<Radio />} label="Self Test" onChange={filterChange} />
                                                        <FormControlLabel value="3" control={<Radio />} label="Adaptive" onChange={filterChange} />
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </>
                                            :
                                            <>
                                                <FormControlLabel value="1" control={<Radio />} label="Assignment" onChange={filterChange} />
                                                <FormControlLabel value="2" control={<Radio />} label="Self Test" onChange={filterChange} />
                                                <FormControlLabel value="3" control={<Radio />} label="Adaptive" onChange={filterChange} />
                                                <FormControlLabel value="4" control={<Radio />} label="Attempted/Closed" onChange={filterChange} />
                                                <FormControlLabel value="5" control={<Radio />} label="Unattempted" onChange={filterChange} />
                                            </>
                                    }

                                </RadioGroup>
                            </FormControl>
                        </Box>
        */
        return (
            <Box style={{ paddingTop: "20px", marginTop: "20px", marginBottom: "20px" }}>
                <Card
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader
                        sx={{ textAlign: 'center', pb: 2 }}
                        title={
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }}
                                variant="h6"
                            >
                                Practice Sessions
                            </Typography>
                        }
                    />
                    <CardContent sx={{ paddingLeft: "10px", paddingTop: "16px" }}>
                        <Box display="flex" alignItems="center" justifyContent="center" sx={{ marginBottom: "10px", color: "primary.main" }}>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    color: 'text.primary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    mr: 1.5
                                }}
                            >
                                <PersonIcon sx={{ color: 'primary.main', fontSize: '1.25rem' }} />
                                Select User:
                            </Typography>
                            <FormControl
                                sx={{
                                    minWidth: 280
                                }}
                            >
                                <InputLabel
                                    sx={{
                                        fontWeight: 500,
                                        '&.Mui-focused': {
                                            color: 'primary.main'
                                        }
                                    }}
                                >
                                    Choose User
                                </InputLabel>
                                <Select
                                    value={assessmentData.whose}
                                    onChange={handleChange}
                                    label="Choose User"
                                    disabled={listLoading}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                borderRadius: 2,
                                                marginTop: 1,
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                '& .MuiMenuItem-root': {
                                                    borderRadius: 1,
                                                    margin: '4px 8px',
                                                    padding: '10px 16px',
                                                    '&:hover': {
                                                        backgroundColor: 'action.hover',
                                                    },
                                                    '&.Mui-selected': {
                                                        backgroundColor: 'primary.light',
                                                        color: 'primary.contrastText',
                                                        '&:hover': {
                                                            backgroundColor: 'primary.main',
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="self">Self</MenuItem>
                                    {enrolledUsers && enrolledUsers.map((row) => (
                                        <MenuItem key={row.ID} value={row.ID}>{row.Username}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box display="flex" alignItems="center" sx={{ marginBottom: "20px", color: "primary.main" }}>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    color: 'text.primary',
                                    mr: 1.5
                                }}
                            >
                                Filter:
                            </Typography>
                            {isActive() || assessmentData.whose !== "self" ?
                                <FormControl sx={{ minWidth: 200, mr: 2 }}>
                                    <InputLabel
                                        sx={{
                                            fontWeight: 500,
                                            '&.Mui-focused': {
                                                color: 'primary.main'
                                            }
                                        }}
                                    >
                                        Type
                                    </InputLabel>
                                    <Select
                                        value={assessmentData.type}
                                        onChange={typeChange}
                                        label="Type"
                                        disabled={listLoading}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    borderRadius: 2,
                                                    marginTop: 1,
                                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    '& .MuiMenuItem-root': {
                                                        borderRadius: 1,
                                                        margin: '4px 8px',
                                                        padding: '10px 16px',
                                                        '&:hover': {
                                                            backgroundColor: 'action.hover',
                                                        },
                                                        '&.Mui-selected': {
                                                            backgroundColor: 'primary.light',
                                                            color: 'primary.contrastText',
                                                            '&:hover': {
                                                                backgroundColor: 'primary.main',
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem value="0">All</MenuItem>
                                        <MenuItem value="1">Assignment</MenuItem>
                                        <MenuItem value="2">Self Test</MenuItem>
                                        <MenuItem value="3">Adaptive</MenuItem>
                                    </Select>
                                </FormControl>
                                : <></>
                            }
                            {
                                assessmentData.whose === "self" ?
                                    <FormControl sx={{ minWidth: 200 }}>
                                        <InputLabel
                                            sx={{
                                                fontWeight: 500,
                                                '&.Mui-focused': {
                                                    color: 'primary.main'
                                                }
                                            }}
                                        >
                                            Status
                                        </InputLabel>
                                        <Select
                                            value={assessmentData.status}
                                            onChange={statusChange}
                                            label="Status"
                                            disabled={listLoading}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: 2,
                                                        marginTop: 1,
                                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        '& .MuiMenuItem-root': {
                                                            borderRadius: 1,
                                                            margin: '4px 8px',
                                                            padding: '10px 16px',
                                                            '&:hover': {
                                                                backgroundColor: 'action.hover',
                                                            },
                                                            '&.Mui-selected': {
                                                                backgroundColor: 'primary.light',
                                                                color: 'primary.contrastText',
                                                                '&:hover': {
                                                                    backgroundColor: 'primary.main',
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            <MenuItem value="0">All</MenuItem>
                                            <MenuItem value="5">Draft</MenuItem>
                                            <MenuItem value="4">Active</MenuItem>
                                            <MenuItem value="3">Closed</MenuItem>
                                        </Select>
                                    </FormControl>
                                    :
                                    <FormControl sx={{ minWidth: 200 }}>
                                        <InputLabel
                                            sx={{
                                                fontWeight: 500,
                                                '&.Mui-focused': {
                                                    color: 'primary.main'
                                                }
                                            }}
                                        >
                                            Status
                                        </InputLabel>
                                        <Select
                                            value={assessmentData.status}
                                            onChange={statusChange}
                                            label="Status"
                                            disabled={listLoading}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: 2,
                                                        marginTop: 1,
                                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        '& .MuiMenuItem-root': {
                                                            borderRadius: 1,
                                                            margin: '4px 8px',
                                                            padding: '10px 16px',
                                                            '&:hover': {
                                                                backgroundColor: 'action.hover',
                                                            },
                                                            '&.Mui-selected': {
                                                                backgroundColor: 'primary.light',
                                                                color: 'primary.contrastText',
                                                                '&:hover': {
                                                                    backgroundColor: 'primary.main',
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            <MenuItem value="0">All</MenuItem>
                                            <MenuItem value="1">Attempted</MenuItem>
                                            <MenuItem value="2">Unattempted</MenuItem>
                                            <MenuItem value="3">Closed</MenuItem>
                                        </Select>
                                    </FormControl>
                            }
                        </Box>

                        <AsyncSection loading={listLoading} minHeight={320}>
                        <Grid2 container spacing={4}>
                            {assessmentData && assessmentData.list && assessmentData.list.length != undefined && assessmentData.list.map((assessment) => (
                                <Grid2 key={assessment.ID} size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Card
                                        elevation={6}
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            position: 'relative',
                                            borderRadius: 3,
                                            paddingRight: "5px",
                                            paddingLeft: "5px",
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            backgroundColor: 'background.paper',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            '&:hover': {
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                                transform: 'translateY(-4px)',
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                pl: "10px",
                                                pr: 2,
                                                pt: 2,
                                                pb: 1,
                                            }}
                                        >
                                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, fontSize: '1.125rem', wordWrap: "break-word", maxWidth: '20ch', paddingRight: "15px" }}>
                                                {assessment.Aname}
                                            </Typography>
                                        </Box>
                                        <CardContent sx={{ paddingLeft: "20px", paddingTop: "0px" }}>

                                            <Box display="none" sx={{ position: "absolute", top: 8, right: 0 }}>
                                                {assessment.Astatus.toLowerCase() == "draft" ? (
                                                    <Tooltip title="Delete">
                                                        <IconButton size="small">
                                                            <Delete type="submit" variant="outlined" color="error"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setDialog({
                                                                        open: true,
                                                                        id: assessment.ID,
                                                                        button: "Delete Assessment",
                                                                        content: "Are you sure you want to remove the assessment " + assessment.Aname + " ?"
                                                                    })
                                                                }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (<></>)}
                                            </Box>
                                            <Box sx={{ mb: 2 }}>
                                                <Chip variant="filled"
                                                    label={assessment.Astatus[0].toUpperCase() + assessment.Astatus.slice(1)}
                                                    size="small"
                                                    color={assessment.Astatus === 'active' || assessment.Astatus === 'attempted' ? 'success' : assessment.Astatus === 'closed' ? 'default' : assessment.Astatus === 'unattempted' ? 'error' : 'warning'}
                                                />

                                            </Box>

                                            <Box sx={{ mb: 2 }}>
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                    <AssignmentIcon color="primary" />
                                                    <Typography variant="body2" color="text.secondary">
                                                        Type: {assessment.Atype}
                                                    </Typography>
                                                    {assessment.IsAdaptive ? <AutoAwesome sx={{ color: 'primary.main' }} /> : <></>}
                                                    {assessment.Duration > 0 && <AccessAlarmIcon sx={{ color: 'primary.main' }} />}

                                                </Stack>
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                    <ClassIcon sx={{ color: "orange" }} />
                                                    <Typography variant="body2" color="text.secondary" >
                                                        Subject: {assessment.Asubject}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                    <SchoolIcon sx={{ color: "brown" }} />
                                                    <Typography variant="body2" color="text.secondary" >
                                                        Class: {assessment.Aclass}
                                                    </Typography>
                                                </Stack>

                                                {assessmentData.whose != "self" &&
                                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                        <PersonIcon sx={{ color: "black" }} />
                                                        <Typography variant="body2" color="text.secondary" >
                                                            Created By: {assessment.CreatorID}
                                                        </Typography>
                                                    </Stack>
                                                }
                                            </Box>

                                            <Box sx={{ mt: 'auto' }}>
                                                {assessment.Astatus.toLowerCase() == "draft" ? (
                                                    <Stack>
                                                        <Button
                                                            type="submit"
                                                            sx={{
                                                                textTransform: "initial",
                                                                marginBottom: "10px",
                                                                transition: 'all 0.2s ease-in-out',
                                                                '&:hover': {
                                                                    backgroundColor: "primary.main",
                                                                    color: "primary.contrastText",
                                                                    transform: 'translateY(-1px)',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                },
                                                            }}
                                                            fullWidth
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={() => { navigate('/app/practice/edit/' + assessment.ID, { replace: false }) }}
                                                        >
                                                            <EditIcon /> Edit
                                                        </Button>
                                                        <Button type="submit" variant="outlined" color="error" sx={{ textTransform: "initial", "&:hover": { backgroundColor: "#d32f2f", color: "white" } }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setDialog({
                                                                    open: true,
                                                                    id: assessment.ID,
                                                                    button: "Delete Assignement",
                                                                    content: "Are you sure you want to remove the assignment " + assessment.Aname + " ?"
                                                                })
                                                            }} >
                                                            <DeleteIcon /> Delete
                                                        </Button>
                                                    </Stack>) : (<></>)}
                                                {assessment.Astatus.toLowerCase() == "active" ? (
                                                    <>
                                                        {assessmentData.whose == "self" && assessment.Atype == "Self Test" ? (
                                                            <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                                                                {assessment.IsAdaptive ?
                                                                    <Button
                                                                        type="submit"
                                                                        sx={{
                                                                            textTransform: "initial",
                                                                            fontWeight: 600,
                                                                            fontSize: '0.875rem',
                                                                            borderRadius: 1.5,
                                                                            px: 2,
                                                                            py: 1,
                                                                            flex: 1,
                                                                            background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                                            boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                                                                            transition: 'all 0.2s ease-in-out',
                                                                            '&:hover': {
                                                                                background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                                                transform: 'translateY(-2px)',
                                                                                boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                                                            },
                                                                        }}
                                                                        variant="contained"
                                                                        color="success"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            navigate("/app/practice/adaptive/attempt/" + assessment.ID)
                                                                        }}
                                                                    >
                                                                        Attempt
                                                                    </Button>
                                                                    : <Button
                                                                        type="submit"
                                                                        sx={{
                                                                            textTransform: "initial",
                                                                            fontWeight: 600,
                                                                            fontSize: '0.875rem',
                                                                            borderRadius: 1.5,
                                                                            px: 2,
                                                                            py: 1,
                                                                            flex: 1,
                                                                            background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                                            boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                                                                            transition: 'all 0.2s ease-in-out',
                                                                            '&:hover': {
                                                                                background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                                                transform: 'translateY(-2px)',
                                                                                boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                                                            },
                                                                        }}
                                                                        variant="contained"
                                                                        color="success"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            navigate("/app/practice/attempt/" + assessment.ID)
                                                                        }}
                                                                    >
                                                                        Attempt
                                                                    </Button>}

                                                            </Box>
                                                        ) : (
                                                            <Stack>
                                                                <Button type="submit" sx={{ textTransform: "initial", marginBottom: "10px", "&:hover": { backgroundColor: "#1b5929ff", color: "white" } }} fullWidth variant="outlined" color="success" onClick={() => { navigate('/app/practice/edit/participants/' + assessment.ID, { replace: false }) }} >
                                                                    <PersonAddIcon />&nbsp;Add Participant
                                                                </Button>
                                                                <Button type="submit" sx={{ textTransform: "initial", marginBottom: "10px", "&:hover": { backgroundColor: "primary.main", color: "primary.contrastText" } }} fullWidth variant="outlined" color="primary" onClick={() => { navigate('/app/practice/review/' + assessment.ID, { replace: false }) }} >
                                                                    <PreviewIcon /> Review
                                                                </Button>
                                                            </Stack>
                                                        )}
                                                    </>
                                                ) : (<></>)}
                                                {assessment.Astatus.toLowerCase() == "attempted" ? (
                                                    <>
                                                        {assessmentData.whose === "self" && (
                                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
                                                                <CheckCircleIcon sx={{ color: "green", fontSize: '1.5rem' }} />
                                                                <Button
                                                                    type="submit"
                                                                    sx={(theme) => ({
                                                                        textTransform: "initial",
                                                                        fontWeight: 500,
                                                                        fontSize: '0.875rem',
                                                                        borderRadius: 1.5,
                                                                        px: 2,
                                                                        py: 1,
                                                                        flex: 1,
                                                                        border: '1.5px solid',
                                                                        borderColor: theme.palette.primary.main,
                                                                        backgroundColor: theme.palette.background.paper,
                                                                        color: theme.palette.primary.main,
                                                                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                                        '&:hover': {
                                                                            backgroundColor: theme.palette.primary.main,
                                                                            color: theme.palette.primary.contrastText,
                                                                            transform: 'translateY(-1px)',
                                                                            boxShadow: theme.palette.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.4)' : '0 2px 8px rgba(255, 152, 0, 0.35)',
                                                                        },
                                                                        transition: 'all 0.2s ease-in-out',
                                                                    })}
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        navigate("/app/practice/review/" + assessment.ID + "/" + assessmentData.whose)
                                                                    }}
                                                                >
                                                                    <PreviewIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Review
                                                                </Button>
                                                            </Box>
                                                        )}
                                                        {assessmentData.whose !== "self" && (
                                                            <Button
                                                                type="submit"
                                                                sx={(theme) => ({
                                                                    textTransform: "initial",
                                                                    fontWeight: 500,
                                                                    fontSize: '0.875rem',
                                                                    borderRadius: 1.5,
                                                                    px: 2,
                                                                    py: 1,
                                                                    width: '100%',
                                                                    border: '1.5px solid',
                                                                    borderColor: theme.palette.primary.main,
                                                                    backgroundColor: theme.palette.background.paper,
                                                                    color: theme.palette.primary.main,
                                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                                    '&:hover': {
                                                                        backgroundColor: theme.palette.primary.main,
                                                                        color: theme.palette.primary.contrastText,
                                                                        transform: 'translateY(-1px)',
                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                    },
                                                                    transition: 'all 0.2s ease-in-out',
                                                                })}
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={() => { navigate("/app/practice/review/" + assessment.ID + "/" + assessmentData.whose, { replace: false }) }}
                                                            >
                                                                <PreviewIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Review
                                                            </Button>
                                                        )}
                                                    </>
                                                ) : (<></>)}
                                                {assessment.Astatus.toLowerCase() == "closed" && (
                                                    <Button
                                                        type="submit"
                                                        sx={(theme) => ({
                                                            textTransform: "initial",
                                                            fontWeight: 500,
                                                            fontSize: '0.875rem',
                                                            borderRadius: 1.5,
                                                            px: 2,
                                                            py: 1,
                                                            width: '100%',
                                                            border: '1.5px solid',
                                                            borderColor: theme.palette.primary.main,
                                                            backgroundColor: theme.palette.background.paper,
                                                            color: theme.palette.primary.main,
                                                            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                            '&:hover': {
                                                                backgroundColor: theme.palette.primary.main,
                                                                color: theme.palette.primary.contrastText,
                                                                transform: 'translateY(-1px)',
                                                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                            },
                                                            transition: 'all 0.2s ease-in-out',
                                                        })}
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => {
                                                            if (assessmentData.whose !== "self") {
                                                                navigate("/app/practice/review/" + assessment.ID + "/" + assessmentData.whose, { replace: false })
                                                            } else {
                                                                navigate('/app/practice/review/' + assessment.ID, { replace: false })
                                                            }
                                                        }}
                                                    >
                                                        <PreviewIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Review
                                                    </Button>
                                                )}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid2>
                            ))}
                        </Grid2>
                        </AsyncSection>
                    </CardContent>
                </Card>
                <Card sx={{ display: "none" }}>
                    <CardContent>

                        <Box style={{ margin: "10px 10px 10px 10px" }}>

                            <TableContainer component={Paper} sx={{ marginTop: "10px" }}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Name</StyledTableCell>
                                            <StyledTableCell>Status</StyledTableCell>
                                            <StyledTableCell >Subject</StyledTableCell>
                                            <StyledTableCell >Class</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {assessmentData && assessmentData.list && assessmentData.list.length != undefined && assessmentData.list.map((row) => (
                                            <StyledTableRow key={row.Aname}>
                                                <StyledTableCell component="th" scope="row">
                                                    {row.Aname}
                                                </StyledTableCell>
                                                <StyledTableCell >{row.Astatus} &nbsp;
                                                    {row.Astatus.toLowerCase() == "draft" ? (
                                                        <>
                                                            <Button type="submit" variant="contained" color="primary" onClick={() => { navigate('/app/practice/edit/' + row.ID, { replace: false }) }} >
                                                                Edit
                                                            </Button>
                                                            <Tooltip title="Delete">
                                                                <IconButton>
                                                                    <Delete type="submit" variant="outlined" color="error"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setDialog({
                                                                                open: true,
                                                                                id: row.ID,
                                                                                button: "Delete Assignement",
                                                                                content: "Are you sure you want to remove the assignement " + row.Aname + " ?"
                                                                            })
                                                                        }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>) : (<></>)}
                                                    {row.Astatus.toLowerCase() == "active" ? (
                                                        <>
                                                            <Tooltip title="Preview">
                                                                <IconButton>
                                                                    <PreviewIcon type="submit" variant="outlined" color="success"
                                                                        onClick={() => { navigate('/app/practice/review/' + row.ID, { replace: false }) }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Add Participant">
                                                                <IconButton>
                                                                    <PersonAddIcon type="submit" variant="outlined" color="primary"
                                                                        onClick={() => { navigate('/app/practice/edit/participants/' + row.ID, { replace: false }) }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    ) : (<></>)}
                                                    {row.Astatus.toLowerCase() == "attempted" ? (
                                                        <>
                                                            {assessmentData.whose === "self" && <> <IconButton>
                                                                <CheckCircleIcon sx={{ "color": "green" }} />
                                                            </IconButton>
                                                                <Button type="submit" variant="contained" color="primary" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    navigate("/app/practice/review/" + row.ID + "/" + assessmentData.whose)
                                                                }} > Review </Button>
                                                            </>
                                                            }
                                                            {assessmentData.whose !== "self" && <>
                                                                <IconButton>
                                                                    <CheckCircleIcon sx={{ "color": "green" }} />
                                                                </IconButton>
                                                                <Button type="submit" variant="contained" color="primary" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    navigate("/app/practice/review/" + row.ID + "/" + assessmentData.whose)
                                                                }} >
                                                                    Review
                                                                </Button>
                                                            </>
                                                            }
                                                        </>
                                                    ) : (<></>)}
                                                    {row.Astatus.toLowerCase() == "notattempted" ? (<></>) : (<></>)}
                                                </StyledTableCell>
                                                <StyledTableCell >{row.Asubject}</StyledTableCell>
                                                <StyledTableCell >{row.Aclass}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>

                    </CardContent>
                </Card>
            </Box>
        );
    };

    const RenderQuickAssessment = () => {

        const [createData, setCreateData] = useState({
            name: '',
            subject: '',
            class: '',
            category: 'any',
            easy: true,
            medium: true,
            advanced: true,
            adaptive: false,
            timed: false,
            durationHours: '',
            durationMinutes: '',
        });

        // Auto-select first subject when subjects are loaded
        useEffect(() => {
            if (subjects.length > 0 && !createData.subject && Object.keys(categories).length > 0) {
                const firstSubject = subjects[0];
                setCreateData(prev => {
                    if (prev.subject) return prev; // Already initialized
                    const newData = { ...prev, subject: firstSubject, class: '', category: 'any' };
                    // Auto-select first class if available
                    if (categories[firstSubject]) {
                        const classes = Object.keys(categories[firstSubject]);
                        if (classes.length > 0) {
                            newData.class = classes[0];
                        }
                    }
                    return newData;
                });
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [subjects.length, Object.keys(categories).length]);

        const { run: runQuickCreate, loading: quickCreating } = useAsyncAction();

        const handleChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            if (name === 'subject') {
                // Reset class and category when subject changes
                setCreateData({ ...createData, subject: value, class: '', category: 'any' });
                // Auto-select first class for new subject
                if (categories[value]) {
                    const classes = Object.keys(categories[value]);
                    if (classes.length > 0) {
                        setTimeout(() => {
                            const firstClass = classes[0];
                            setCreateData(prev => {
                                const newData = { ...prev, class: firstClass, category: 'any' };
                                return newData;
                            });
                        }, 0);
                    }
                }
            } else if (name === 'class') {
                // Reset category when class changes
                setCreateData({ ...createData, class: value, category: 'any' });
            } else {
                setCreateData({ ...createData, [name]: value });
            }
        };
        const handleLevelChange = (e) => {
            //e.preventDefault();
            const name = e.target.id;
            const value = e.target.checked;
            setCreateData({ ...createData, [name]: value });
        }
        const handleCreate = async (event) => {
            event.preventDefault();
            await runQuickCreate(async () => {
                const hours = parseInt(createData.durationHours, 10) || 0;
                const minutes = parseInt(createData.durationMinutes, 10) || 0;
                const durationMinutes = createData.timed ? (hours * 60 + minutes) : 0;
                const status = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/quick/create`,
                    {
                        "Aname": createData.name,
                        "Asubject": createData.subject,
                        "Aclass": createData.class,
                        "Qcategory": createData.category,
                        "Easy": createData.easy,
                        "Medium": createData.medium,
                        "Advanced": createData.advanced,
                        "Adaptive": createData.adaptive,
                        "Duration": durationMinutes.toString(),
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if ((isTrialState || isExpiredState) && status.unauthorized) {
                    setState({ open: true, severity: "error", message: "Your trial limit is over. Activate to create." })
                    navigate("/app/activate")
                } else if (status["unauthenticated"] == true || status["unauthorized"] == true) {
                    logout(user);
                } else if (status.alreadyExists) {
                    //alert("username already exists")
                    setState({ open: true, severity: "warning", message: "Assessment name alreday exists" })
                } else if (status.iserror) {
                    console.log(status)
                    setState({ open: true, severity: "error", message: "Error creating Assessment" })
                } else {
                    console.log(status)
                    setState({ open: true, severity: "success", message: "Assessment created successfully" })
                    if (createData.adaptive === false) {
                        navigate("/app/practice/attempt/" + status.response.ID)
                    } else {
                        navigate("/app/practice/adaptive/attempt/" + status.response.ID)
                    }

                }
            });
        };
        /*
<CardHeader title={<Typography variant="h6" gutterBottom sx={{ display: "none",fontWeight: 600 }}>
    Self Test
                    </Typography>} />

        */

        console.log(createData.subject)
        console.log(createData.category)
        console.log(categories)
        return (
            <Paper
                elevation={0}
                sx={{
                    borderRadius: '0 0 16px 16px',
                    boxShadow: (theme) => theme.palette.mode === 'dark'
                        ? '0 8px 32px rgba(0,0,0,0.5)'
                        : '0 8px 32px rgba(0,0,0,0.12)',
                    width: '100%',
                    overflow: 'hidden',
                    backgroundColor: 'background.paper',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    marginTop: 0,
                }}
            >
                <Box sx={{ padding: "20px 30px" }}>
                    <Grid2 container spacing={4}>
                        <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                            <Stack spacing={3}>
                                <Box>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <AssignmentIcon color="primary" />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Name
                                        </Typography>
                                    </Stack>
                                    <TextField
                                        label={createData.name ? "" : "Self Test Name"}
                                        variant="outlined"
                                        name="name"
                                        value={createData.name}
                                        onChange={handleChange}
                                        required
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                    />
                                </Box>
                                <Grid2 container spacing={2}>
                                    <Grid2 size={{ xs: 12, sm: 4 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <ClassIcon sx={{ color: "orange" }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                                Subject
                                            </Typography>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.subject}
                                                onChange={handleChange}
                                                name="subject"
                                                displayEmpty
                                                sx={(theme) => ({
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '1px',
                                                        borderStyle: 'solid',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '2px',
                                                        borderColor: theme.palette.primary.main,
                                                    },
                                                })}
                                            >
                                                {subjects && subjects.map((row) => (
                                                    <MenuItem key={row} value={row}>{row}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, sm: 4 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <SchoolIcon sx={{ color: "brown" }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                                Class
                                            </Typography>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.class || ''}
                                                onChange={handleChange}
                                                name="class"
                                                displayEmpty
                                                disabled={!createData.subject}
                                                sx={(theme) => ({
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '1px',
                                                        borderStyle: 'solid',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '2px',
                                                        borderColor: theme.palette.primary.main,
                                                    },
                                                })}
                                            >
                                                {createData.subject && categories[createData.subject] && Object.keys(categories[createData.subject]).map((cls) => (
                                                    <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, sm: 4 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <LabelIcon sx={{ color: '#9c27b0' }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                                Categories
                                            </Typography>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.category || ''}
                                                onChange={handleChange}
                                                name="category"
                                                displayEmpty
                                                disabled={!createData.subject || !createData.class}
                                                sx={(theme) => ({
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '1px',
                                                        borderStyle: 'solid',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '2px',
                                                        borderColor: theme.palette.primary.main,
                                                    },
                                                })}
                                            >
                                                <MenuItem value="any">Any</MenuItem>
                                                {createData.subject && createData.class && categories[createData.subject] && categories[createData.subject][createData.class] && categories[createData.subject][createData.class].map((cat) => (
                                                    <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                </Grid2>
                                <Grid2 container spacing={2}>
                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <AutoAwesome sx={{ color: 'primary.main' }} />
                                    <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                        Adaptive
                                    </Typography>
                                    <Tooltip
                                        title="Adaptive adjusts next question difficulty based on prior answers. When enabled, manual difficulty selection is disabled."
                                        arrow
                                        placement="right"
                                    >
                                        <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
                                    </Tooltip>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.adaptive ? 'Yes' : 'No'}
                                                onChange={(e) => {
                                                    setCreateData({ ...createData, adaptive: e.target.value === 'Yes' });
                                                }}
                                                displayEmpty
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSelect-select': {
                                                        backgroundColor: createData.adaptive ? 'primary.main' : 'background.paper',
                                                        color: createData.adaptive ? 'primary.contrastText' : 'text.primary',
                                                        fontWeight: createData.adaptive ? 600 : 400,
                                                        borderRadius: 2,
                                                        border: '1px solid',
                                                        borderColor: createData.adaptive ? 'primary.main' : 'divider',
                                                        transition: 'all 0.2s ease-in-out',
                                                        '&:hover': {
                                                            borderColor: 'primary.main',
                                                        }
                                                    }
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: 2,
                                                            marginTop: 1,
                                                            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            '& .MuiMenuItem-root': {
                                                                borderRadius: 1,
                                                                margin: '4px 8px',
                                                                padding: '10px 16px',
                                                                '&:hover': {
                                                                    backgroundColor: 'action.hover',
                                                                },
                                                                '&.Mui-selected': {
                                                                    backgroundColor: 'primary.light',
                                                                    color: 'primary.contrastText',
                                                                    '&:hover': {
                                                                        backgroundColor: 'primary.main',
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="Yes">Yes</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <TrendingUpIcon sx={{ color: '#f57c00' }} />
                                    <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                        Difficulty Level
                                    </Typography>
                                    <Tooltip
                                        title="Choose which difficulty levels to include. This is unavailable when Adaptive is enabled."
                                        arrow
                                        placement="right"
                                    >
                                        <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
                                    </Tooltip>
                                        </Stack>
                                        <FormControl fullWidth disabled={createData.adaptive}>
                                            <Select
                                                multiple
                                                disabled={createData.adaptive}
                                                value={[
                                                    ...(createData.easy ? ['Easy'] : []),
                                                    ...(createData.medium ? ['Medium'] : []),
                                                    ...(createData.advanced ? ['Advanced'] : [])
                                                ]}
                                                onChange={(e) => {
                                                    const selected = e.target.value;
                                                    setCreateData({
                                                        ...createData,
                                                        easy: selected.includes('Easy'),
                                                        medium: selected.includes('Medium'),
                                                        advanced: selected.includes('Advanced')
                                                    });
                                                }}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    if (selected.length === 0) {
                                                        return <em style={{ color: 'rgba(0, 0, 0, 0.6)' }}>Select Difficulty</em>;
                                                    }
                                                    return selected.join(', ');
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSelect-select': {
                                                        backgroundColor: createData.adaptive ? 'action.disabledBackground' : 'background.paper',
                                                        color: createData.adaptive ? 'action.disabled' : 'text.primary',
                                                        fontWeight: 400,
                                                        borderRadius: 2,
                                                        border: '1px solid',
                                                        borderColor: createData.adaptive ? 'action.disabled' : 'divider',
                                                        transition: 'all 0.2s ease-in-out',
                                                        '&:hover': {
                                                            borderColor: createData.adaptive ? 'action.disabled' : 'primary.main',
                                                        }
                                                    }
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: 2,
                                                            marginTop: 1,
                                                            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            '& .MuiMenuItem-root': {
                                                                borderRadius: 1,
                                                                margin: '4px 8px',
                                                                padding: '10px 16px',
                                                                '&:hover': {
                                                                    backgroundColor: 'action.hover',
                                                                },
                                                                '&.Mui-selected': {
                                                                    backgroundColor: 'primary.light',
                                                                    color: 'primary.contrastText',
                                                                    '&:hover': {
                                                                        backgroundColor: 'primary.main',
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                <MenuItem value="Easy">Easy</MenuItem>
                                                <MenuItem value="Medium">Medium</MenuItem>
                                                <MenuItem value="Advanced">Advanced</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                </Grid2>
                                <Box sx={{ pt: 2 }}>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2, flexWrap: 'wrap' }}>
                                        <Checkbox
                                            checked={createData.timed}
                                            onChange={(e) => {
                                                setCreateData({
                                                    ...createData,
                                                    timed: e.target.checked,
                                                    durationHours: e.target.checked ? createData.durationHours : '',
                                                    durationMinutes: e.target.checked ? createData.durationMinutes : ''
                                                });
                                            }}
                                            color="primary"
                                        />
                                        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Timed
                                        </Typography>
                                        {createData.timed && (
                                            <>
                                                <TextField
                                                    label="Hours"
                                                    variant="outlined"
                                                    name="durationHours"
                                                    type="number"
                                                    value={createData.durationHours}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const formatted = value.replace(/[^\d]/g, '').slice(0, 2);
                                                        setCreateData({ ...createData, durationHours: formatted });
                                                    }}
                                                    placeholder="00"
                                                    inputProps={{ min: 0, max: 99 }}
                                                    sx={{ width: '100px' }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <Typography variant="h6" sx={{ color: 'text.secondary' }}>:</Typography>
                                                <TextField
                                                    label="Minutes"
                                                    variant="outlined"
                                                    name="durationMinutes"
                                                    type="number"
                                                    value={createData.durationMinutes}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const formatted = value.replace(/[^\d]/g, '').slice(0, 2);
                                                        const numValue = parseInt(formatted, 10);
                                                        if (isNaN(numValue) || numValue <= 59) {
                                                            setCreateData({ ...createData, durationMinutes: formatted });
                                                        }
                                                    }}
                                                    placeholder="00"
                                                    inputProps={{ min: 0, max: 59 }}
                                                    sx={{ width: '100px' }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </>
                                        )}
                                    </Stack>
                                </Box>
                                <Box display="flex" justifyContent="center" sx={{ pt: 2 }}>
                                    <AsyncButton type="submit" variant="contained" color="primary" onClick={handleCreate} loading={quickCreating}>
                                        <PlayCircleOutlineIcon /> &nbsp; Take Test
                                    </AsyncButton>
                                </Box>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </Box>
            </Paper>
        );
    }

    const RenderStudentList = () => {
        /*
            Based on Aids status
            Attempt
            ReAttempt
            Finished - no attempt only review
        */
        const [assessmentData, setAssessmentData] = useState({
            'list': [],
            'type': "0",
            'status': "0"
        });
        const { run: runStudentListLoad, loading: studentListLoading } = useAsyncAction();

        const getAssessmentData = async (type, status) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assigned/user`,
                {
                    "UserID": user["id"],
                    "Type": type,
                    "Status": status,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["AssessmentInfo"]
        }

        useEffect(() => {
            //Some function
            getAssessmentData(assessmentData.type, assessmentData.status).then(data => setAssessmentData({ 'list': data, 'type': assessmentData.type, 'status': assessmentData.status }))
        }, [])



        const typeChange = async (e) => {
            e.preventDefault();
            const type = parseInt(e.target.value, 10);
            await runStudentListLoad(async () => {
                const status = parseInt(assessmentData.status, 10);
                const data = await getAssessmentData(type, status);
                setAssessmentData({ 'list': data, 'type': type, 'status': assessmentData.status });
            });
        }

        const statusChange = async (e) => {
            e.preventDefault();
            const status = parseInt(e.target.value, 10);
            await runStudentListLoad(async () => {
                const type = parseInt(assessmentData.type, 10);
                const data = await getAssessmentData(type, status);
                setAssessmentData({ 'list': data, 'type': assessmentData.type, 'status': status });
            });
        }


        return (
            <Box style={{ paddingTop: "30px", margin: "10px 10px 10px 10px" }}>
                <Card
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader
                        sx={{ textAlign: 'center', pb: 2 }}
                        title={
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }}
                                variant="h6"
                            >
                                Practice Sessions
                            </Typography>
                        }
                    />
                    <CardContent sx={{ paddingLeft: "10px", paddingTop: "16px" }}>
                        <Box display="flex" alignItems="center" sx={{ marginBottom: "20px", color: "primary.main" }}>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    color: 'text.primary',
                                    mr: 1.5
                                }}
                            >
                                Filter:
                            </Typography>
                            {isActive() ?
                                <FormControl sx={{ minWidth: 200, mr: 2 }}>
                                    <InputLabel
                                        sx={{
                                            fontWeight: 500,
                                            '&.Mui-focused': {
                                                color: 'primary.main'
                                            }
                                        }}
                                    >
                                        Type
                                    </InputLabel>
                                    <Select
                                        value={assessmentData.type}
                                        onChange={typeChange}
                                        label="Type"
                                        disabled={studentListLoading}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    borderRadius: 2,
                                                    marginTop: 1,
                                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    '& .MuiMenuItem-root': {
                                                        borderRadius: 1,
                                                        margin: '4px 8px',
                                                        padding: '10px 16px',
                                                        '&:hover': {
                                                            backgroundColor: 'action.hover',
                                                        },
                                                        '&.Mui-selected': {
                                                            backgroundColor: 'primary.light',
                                                            color: 'primary.contrastText',
                                                            '&:hover': {
                                                                backgroundColor: 'primary.main',
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem value="0">All</MenuItem>
                                        <MenuItem value="1">Assignment</MenuItem>
                                        <MenuItem value="2">Self Test</MenuItem>
                                        <MenuItem value="3">Adaptive</MenuItem>
                                    </Select>
                                </FormControl>
                                : <></>
                            }

                            <FormControl sx={{ minWidth: 200 }}>
                                <InputLabel
                                    sx={{
                                        fontWeight: 500,
                                        '&.Mui-focused': {
                                            color: 'primary.main'
                                        }
                                    }}
                                >
                                    Status
                                </InputLabel>
                                <Select
                                    value={assessmentData.status}
                                    onChange={statusChange}
                                    label="Status"
                                    disabled={studentListLoading}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                borderRadius: 2,
                                                marginTop: 1,
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                '& .MuiMenuItem-root': {
                                                    borderRadius: 1,
                                                    margin: '4px 8px',
                                                    padding: '10px 16px',
                                                    '&:hover': {
                                                        backgroundColor: 'action.hover',
                                                    },
                                                    '&.Mui-selected': {
                                                        backgroundColor: 'primary.light',
                                                        color: 'primary.contrastText',
                                                        '&:hover': {
                                                            backgroundColor: 'primary.main',
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="0">All</MenuItem>
                                    <MenuItem value="1">Attempted</MenuItem>
                                    <MenuItem value="2">Unattempted</MenuItem>
                                    <MenuItem value="3">Closed</MenuItem>
                                </Select>
                            </FormControl>

                        </Box>
                        <AsyncSection loading={studentListLoading} minHeight={320}>
                        <Grid2 container spacing={4}>
                            {assessmentData && assessmentData.list && assessmentData.list.length != undefined && assessmentData.list.map((assessment) => (
                                <Grid2 key={assessment.ID} size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Card
                                        elevation={6}
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            position: 'relative',
                                            borderRadius: 3,
                                            paddingRight: "5px",
                                            paddingLeft: "5px",
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            backgroundColor: 'background.paper',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            '&:hover': {
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                                transform: 'translateY(-4px)',
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                pl: "10px",
                                                pr: 2,
                                                pt: 2,
                                                pb: 1,
                                                bgcolor: "background.paper",
                                            }}
                                        >
                                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, fontSize: '1.125rem', wordWrap: "break-word", maxWidth: '20ch', paddingRight: "15px" }}>
                                                {assessment.Aname}
                                            </Typography>
                                        </Box>
                                        <CardContent sx={{ paddingLeft: "20px", paddingTop: "0px" }}>
                                            <Box display="none" sx={{ position: "absolute", top: 8, right: 0 }}>
                                                {assessment.Astatus.toLowerCase() == "draft" ? (
                                                    <Tooltip title="Delete">
                                                        <IconButton size="small">
                                                            <Delete type="submit" variant="outlined" color="error"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setDialog({
                                                                        open: true,
                                                                        id: assessment.ID,
                                                                        button: "Delete Assignment",
                                                                        content: "Are you sure you want to remove the assignment " + assessment.Aname + " ?"
                                                                    })
                                                                }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (<></>)}
                                            </Box>
                                            <Box sx={{ mb: 2 }}>
                                                <Chip variant="filled"
                                                    label={assessment.Astatus[0].toUpperCase() + assessment.Astatus.slice(1)}
                                                    size="small"
                                                    color={assessment.Astatus === 'active' || assessment.Astatus === 'attempted' ? 'success' : assessment.Astatus === 'closed' ? 'default' : assessment.Astatus === 'unattempted' ? 'error' : 'warning'}
                                                />

                                            </Box>

                                            <Box sx={{ mb: 2 }}>
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                    <AssignmentIcon color="primary" />
                                                    <Typography variant="body2" color="text.secondary" sx={{ paddingBottom: "5px" }}>
                                                        Type: {assessment.Atype}
                                                    </Typography>
                                                    {assessment.IsAdaptive ? <AutoAwesome sx={{ color: 'primary.main' }} /> : <></>}
                                                    {assessment.Duration > 0 && <AccessAlarmIcon sx={{ color: 'primary.main' }} />}
                                                </Stack>
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                    <ClassIcon sx={{ color: "orange" }} />
                                                    <Typography variant="body2" color="text.secondary" >
                                                        Subject: {assessment.Asubject}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                    <SchoolIcon sx={{ color: "brown" }} />
                                                    <Typography variant="body2" color="text.secondary" >
                                                        Class: {assessment.Aclass}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>
                                                    <PersonIcon sx={{ color: "black" }} />
                                                    <Typography variant="body2" color="text.secondary" >
                                                        Created By: {assessment.CreatorID}
                                                    </Typography>
                                                </Stack>
                                            </Box>

                                            <Box sx={{ mt: 'auto' }}>
                                                {assessment.Astatus.toLowerCase() == "draft" ? (
                                                    <Stack>
                                                        <Button type="submit" sx={{ textTransform: "initial", marginBottom: "10px", "&:hover": { backgroundColor: "#1976d2", color: "white" } }} fullWidth variant="outlined" color="primary" onClick={() => { navigate('/app/practice/edit/' + assessment.ID, { replace: false }) }} >
                                                            <EditIcon /> Edit
                                                        </Button>
                                                        <Button type="submit" variant="outlined" color="error" sx={{ textTransform: "initial", "&:hover": { backgroundColor: "#d32f2f", color: "white" } }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setDialog({
                                                                    open: true,
                                                                    id: assessment.ID,
                                                                    button: "Delete Assignement",
                                                                    content: "Are you sure you want to remove the assignment " + assessment.Aname + " ?"
                                                                })
                                                            }} >
                                                            <DeleteIcon /> Delete
                                                        </Button>
                                                    </Stack>) : (<></>)}
                                                {assessment.Astatus.toLowerCase() == "active" ? (
                                                    <Stack>
                                                        <Button type="submit" sx={{ textTransform: "initial", marginBottom: "10px", "&:hover": { backgroundColor: "#1b5929ff", color: "white" } }} fullWidth variant="outlined" color="success" onClick={() => { navigate('/app/practice/edit/participants/' + assessment.ID, { replace: false }) }} >
                                                            <PersonAddIcon />&nbsp;Add Participant
                                                        </Button>
                                                        <Button type="submit" sx={{ textTransform: "initial", marginBottom: "10px", "&:hover": { backgroundColor: "primary.main", color: "primary.contrastText" } }} fullWidth variant="outlined" color="primary" onClick={() => { navigate('/app/practice/review/' + assessment.ID, { replace: false }) }} >
                                                            <PreviewIcon /> Review
                                                        </Button>
                                                    </Stack>
                                                ) : (<></>)}
                                                {assessment.Astatus.toLowerCase() == "unattempted" ? (
                                                    <>
                                                        {assessment.IsAdaptive ?
                                                            <Button
                                                                type="submit"
                                                                sx={{
                                                                    textTransform: "initial",
                                                                    fontWeight: 600,
                                                                    fontSize: '0.875rem',
                                                                    borderRadius: 1.5,
                                                                    px: 2,
                                                                    py: 1,
                                                                    width: '100%',
                                                                    background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                                                                    transition: 'all 0.2s ease-in-out',
                                                                    '&:hover': {
                                                                        background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                                        transform: 'translateY(-2px)',
                                                                        boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                                                    },
                                                                }}
                                                                variant="contained"
                                                                color="success"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    navigate("/app/practice/adaptive/attempt/" + assessment.ID)
                                                                }}
                                                            >
                                                                Attempt
                                                            </Button>
                                                            :
                                                            <Button
                                                                type="submit"
                                                                sx={{
                                                                    textTransform: "initial",
                                                                    fontWeight: 600,
                                                                    fontSize: '0.875rem',
                                                                    borderRadius: 1.5,
                                                                    px: 2,
                                                                    py: 1,
                                                                    width: '100%',
                                                                    background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                                                                    transition: 'all 0.2s ease-in-out',
                                                                    '&:hover': {
                                                                        background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                                        transform: 'translateY(-2px)',
                                                                        boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                                                    },
                                                                }}
                                                                variant="contained"
                                                                color="success"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    navigate("/app/practice/attempt/" + assessment.ID)
                                                                }}
                                                            >
                                                                Attempt
                                                            </Button>
                                                        }
                                                    </>
                                                ) : (<></>)}
                                                {assessment.Astatus.toLowerCase() == "attempted" || assessment.Astatus.toLowerCase() == "closed" ? (
                                                    <>
                                                        {assessmentData.whose !== "self" && (
                                                            <Button
                                                                type="submit"
                                                                sx={(theme) => ({
                                                                    textTransform: "initial",
                                                                    fontWeight: 500,
                                                                    fontSize: '0.875rem',
                                                                    borderRadius: 1.5,
                                                                    px: 2,
                                                                    py: 1,
                                                                    width: '100%',
                                                                    border: '1.5px solid',
                                                                    borderColor: theme.palette.primary.main,
                                                                    backgroundColor: theme.palette.background.paper,
                                                                    color: theme.palette.primary.main,
                                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                                    '&:hover': {
                                                                        backgroundColor: theme.palette.primary.main,
                                                                        color: theme.palette.primary.contrastText,
                                                                        transform: 'translateY(-1px)',
                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                    },
                                                                    transition: 'all 0.2s ease-in-out',
                                                                })}
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={() => { navigate("/app/practice/review/" + assessment.ID, { replace: false }) }}
                                                            >
                                                                <PreviewIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Review
                                                            </Button>
                                                        )}
                                                    </>
                                                ) : (<></>)}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid2>
                            ))}
                        </Grid2>
                        </AsyncSection>
                    </CardContent>
                </Card>
                <TableContainer sx={{ display: "none" }} component={Paper}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Name</StyledTableCell>
                                <StyledTableCell >Subject</StyledTableCell>
                                <StyledTableCell >Class</StyledTableCell>
                                <StyledTableCell >Status</StyledTableCell>
                                <StyledTableCell >CreatedBy</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {assessmentData && assessmentData.list.map((row) => (
                                <StyledTableRow key={row.Aname}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.Aname} &nbsp;
                                        {row.Astatus === "unattempted" ? (
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="success"
                                                sx={{
                                                    textTransform: "initial",
                                                    fontWeight: 600,
                                                    fontSize: '0.875rem',
                                                    borderRadius: 1.5,
                                                    px: 2,
                                                    py: 0.75,
                                                    background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                                                    transition: 'all 0.2s ease-in-out',
                                                    '&:hover': {
                                                        background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                        transform: 'translateY(-2px)',
                                                        boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                                    },
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate("/app/practice/attempt/" + row.ID)
                                                }}
                                            >
                                                Attempt
                                            </Button>
                                        ) : (
                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                <CheckCircleIcon sx={{ color: "green", fontSize: '1.5rem' }} />
                                                <Button
                                                    type="submit"
                                                    variant="outlined"
                                                    color="primary"
                                                    sx={(theme) => ({
                                                        textTransform: "initial",
                                                        fontWeight: 500,
                                                        fontSize: '0.875rem',
                                                        borderRadius: 1.5,
                                                        px: 2,
                                                        py: 0.75,
                                                        border: '1.5px solid',
                                                        borderColor: theme.palette.primary.main,
                                                        backgroundColor: theme.palette.background.paper,
                                                        color: theme.palette.primary.main,
                                                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                        '&:hover': {
                                                            backgroundColor: theme.palette.primary.main,
                                                            color: theme.palette.primary.contrastText,
                                                            transform: 'translateY(-1px)',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                        },
                                                        transition: 'all 0.2s ease-in-out',
                                                    })}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        navigate("/app/practice/review/" + row.ID)
                                                    }}
                                                >
                                                    <PreviewIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Review
                                                </Button>
                                            </Box>
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell >{row.Asubject}</StyledTableCell>
                                    <StyledTableCell >{row.Aclass}</StyledTableCell>
                                    <StyledTableCell >{row.Astatus}</StyledTableCell>
                                    <StyledTableCell >{row.CreatorID}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    };

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
                style={{ marginTop: 0, paddingTop: 0 }}
            >
                {value === index && <Box sx={{ marginTop: 0, paddingTop: 0 }}>{children}</Box>}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const isStudentUser = isStudent();
    const hasQuickTab = isStudentUser || isActive() || isTrial();
    const canCreateAssignment = !isStudentUser;
    const canManageList = !isStudentUser;
    const tourSections = [
        {
            title: "Tabs",
            description: "Use these tabs to switch between creating assignments and self tests.",
            targetRef: tabsRef,
            tab: null,
        },
        ...(canCreateAssignment ? [{
            title: "Create Assignment",
            description: "Create a standard assignment by selecting subject, class, and duration. In edit mode, you can add questions to the assignment and add participants to the assignment who will attempt the assignment.",
            targetRef: createPanelRef,
            tab: 0,
        }] : []),
        ...(hasQuickTab ? [{
            title: "Self Test",
            description: "Create a quick self test and configure category, duration, difficulty or adaptive mode. Here the creator will attempt the self test and get the results.",
            targetRef: quickPanelRef,
            tab: canCreateAssignment ? 1 : 0,
        }] : []),
        {
            title: canManageList ? "Practice Session List" : "My Practice Sessions",
            description: canManageList
                ? "Review all practice sessions and use actions like edit, participants, publish, attempt, and review."
                : "Track your self tests and open attempts or reviews from this section.",
            targetRef: listPanelRef,
            tab: null,
        },
    ];

    const startTour = () => {
        setTourSection(0);
        setTourOpen(true);
    };

    const closeTour = () => {
        setTourOpen(false);
    };

    const goToTourSection = (nextSection) => {
        if (nextSection < 0) return;
        if (nextSection >= tourSections.length) {
            closeTour();
            return;
        }
        const next = tourSections[nextSection];
        if (typeof next.tab === "number") {
            setValue(next.tab);
        }
        setTourSection(nextSection);
    };

    useEffect(() => {
        if (!tourOpen) return;
        const target = tourSections[tourSection]?.targetRef?.current;
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [tourOpen, tourSection, value]);


    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={1000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Dialog
                open={dialog.open}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialog.content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <AsyncButton onClick={handleDialogContinue} sx={{ textTransform: "initial" }} loading={dialogSubmitting}>
                        {dialog.button}
                    </AsyncButton>
                    <Button onClick={handleDialogClose} autoFocus disabled={dialogSubmitting}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ backgroundColor: 'background.default' }}>
                <Box sx={{ display: "flex", justifyContent: "right", alignItems: "center", mb: 1 }}>
                    <Button variant="outlined" onClick={startTour}>
                        Take a tour
                    </Button>
                </Box>
                {!isStudent() && !isActive() && !isTrial() ?
                    <>
                        <Box
                            ref={tabsRef}
                            sx={{
                                display: 'flex',
                                backgroundColor: 'transparent',
                                borderRadius: '16px 16px 0 0',
                                padding: 0,
                                gap: 0,
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === tabsRef ? 'primary.main' : 'transparent',
                                boxShadow: tourOpen && tourSections[tourSection]?.targetRef === tabsRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                            }}
                        >
                            <Button
                                variant={value === 0 ? 'contained' : 'text'}
                                onClick={(e) => handleChange(e, 0)}
                                sx={{
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: value === 0 ? 600 : 500,
                                    fontSize: '1rem',
                                    borderRadius: '16px 16px 0 0',
                                    py: 1.5,
                                    transition: 'all 0.2s ease-in-out',
                                    boxShadow: 'none',
                                    overflow: 'hidden',
                                    border: 'none',
                                    outline: 'none',
                                    '&:focus': {
                                        outline: 'none',
                                        border: 'none',
                                    },
                                    '&:hover': {
                                        backgroundColor: value === 0
                                            ? 'primary.dark'
                                            : (theme) => theme.palette.mode === 'dark'
                                                ? 'rgba(255, 255, 255, 0.08)'
                                                : 'rgba(0, 0, 0, 0.04)',
                                    },
                                }}
                            >
                                Create Assignment
                            </Button>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <Box
                                ref={createPanelRef}
                                sx={{
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === createPanelRef ? 'primary.main' : 'transparent',
                                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === createPanelRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                                }}
                            >
                                <RenderCreate />
                            </Box>
                        </CustomTabPanel>
                    </>
                    : <></>}
                {!isStudent() && (isActive() || isTrial()) ?
                    <>
                        <Box
                            ref={tabsRef}
                            sx={{
                                display: 'flex',
                                backgroundColor: 'transparent',
                                borderRadius: '16px 16px 0 0',
                                padding: 0,
                                gap: 0,
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === tabsRef ? 'primary.main' : 'transparent',
                                boxShadow: tourOpen && tourSections[tourSection]?.targetRef === tabsRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                            }}
                        >
                            <Button
                                variant={value === 0 ? 'contained' : 'text'}
                                onClick={(e) => handleChange(e, 0)}
                                sx={{
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: value === 0 ? 600 : 500,
                                    fontSize: '1rem',
                                    borderRadius: value === 0 ? '16px 0 0 0' : '16px 16px 0 0',
                                    py: 1.5,
                                    transition: 'all 0.2s ease-in-out',
                                    boxShadow: 'none',
                                    overflow: 'hidden',
                                    border: 'none',
                                    outline: 'none',
                                    '&:focus': {
                                        outline: 'none',
                                        border: 'none',
                                    },
                                    '&:hover': {
                                        backgroundColor: value === 0
                                            ? 'primary.dark'
                                            : (theme) => theme.palette.mode === 'dark'
                                                ? 'rgba(255, 255, 255, 0.08)'
                                                : 'rgba(0, 0, 0, 0.04)',
                                    },
                                }}
                            >
                                Create Assignment
                            </Button>
                            <Button
                                variant={value === 1 ? 'contained' : 'text'}
                                onClick={(e) => handleChange(e, 1)}
                                sx={{
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: value === 1 ? 600 : 500,
                                    fontSize: '1rem',
                                    borderRadius: value === 1 ? '0 16px 0 0' : '0 0 0 0',
                                    py: 1.5,
                                    transition: 'all 0.2s ease-in-out',
                                    boxShadow: 'none',
                                    overflow: 'hidden',
                                    border: 'none',
                                    outline: 'none',
                                    '&:focus': {
                                        outline: 'none',
                                        border: 'none',
                                    },
                                    '&:hover': {
                                        backgroundColor: value === 1
                                            ? 'primary.dark'
                                            : (theme) => theme.palette.mode === 'dark'
                                                ? 'rgba(255, 255, 255, 0.08)'
                                                : 'rgba(0, 0, 0, 0.04)',
                                    },
                                }}
                            >
                                Self Test
                            </Button>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <Box
                                ref={createPanelRef}
                                sx={{
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === createPanelRef ? 'primary.main' : 'transparent',
                                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === createPanelRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                                }}
                            >
                                <RenderCreate />
                            </Box>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <Box
                                ref={quickPanelRef}
                                sx={{
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === quickPanelRef ? 'primary.main' : 'transparent',
                                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === quickPanelRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                                }}
                            >
                                <RenderQuickAssessment />
                            </Box>
                        </CustomTabPanel>
                    </>
                    : <></>}
                {isStudent() ?
                    <>
                        <Box
                            ref={tabsRef}
                            sx={{
                                display: 'flex',
                                backgroundColor: 'transparent',
                                borderRadius: '16px 16px 0 0',
                                padding: 0,
                                gap: 0,
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === tabsRef ? 'primary.main' : 'transparent',
                                boxShadow: tourOpen && tourSections[tourSection]?.targetRef === tabsRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                            }}
                        >
                            <Button
                                variant={value === 0 ? 'contained' : 'text'}
                                onClick={(e) => handleChange(e, 0)}
                                sx={{
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: value === 0 ? 600 : 500,
                                    fontSize: '1rem',
                                    borderRadius: '16px 16px 0 0',
                                    py: 1.5,
                                    transition: 'all 0.2s ease-in-out',
                                    boxShadow: 'none',
                                    overflow: 'hidden',
                                    border: 'none',
                                    outline: 'none',
                                    '&:focus': {
                                        outline: 'none',
                                        border: 'none',
                                    },
                                    '&:hover': {
                                        backgroundColor: value === 0
                                            ? 'primary.dark'
                                            : (theme) => theme.palette.mode === 'dark'
                                                ? 'rgba(255, 255, 255, 0.08)'
                                                : 'rgba(0, 0, 0, 0.04)',
                                    },
                                }}
                            >
                                Self Test
                            </Button>
                        </Box>

                        <CustomTabPanel value={value} index={0}>
                            <Box
                                ref={quickPanelRef}
                                sx={{
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === quickPanelRef ? 'primary.main' : 'transparent',
                                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === quickPanelRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                                }}
                            >
                                <RenderQuickAssessment />
                            </Box>
                        </CustomTabPanel>
                    </>
                    : <></>}
            </Box>
            <Box
                ref={listPanelRef}
                sx={{
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === listPanelRef ? 'primary.main' : 'transparent',
                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === listPanelRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                }}
            >
                {isStudent() ? <RenderStudentList /> : <RenderList />}
            </Box>
            {tourOpen && (
                <Paper
                    elevation={12}
                    sx={{
                        position: "fixed",
                        right: 24,
                        bottom: 24,
                        width: { xs: "calc(100% - 32px)", sm: 390 },
                        p: 2,
                        borderRadius: 2,
                        zIndex: 2000,
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        Section {tourSection + 1} of {tourSections.length}: {tourSections[tourSection].title}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                        {tourSections[tourSection].description}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                        <Button onClick={closeTour} color="inherit">
                            Skip
                        </Button>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                                variant="outlined"
                                onClick={() => goToTourSection(tourSection - 1)}
                                disabled={tourSection === 0}
                            >
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => goToTourSection(tourSection + 1)}
                            >
                                {tourSection === tourSections.length - 1 ? "Done" : "Next"}
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            )}
        </Box>
    );
};

export default AssessmentList;
